module.exports = __WEBPACK_EXTERNAL_MODULE_147__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/core-client/js/core-client/utils/BrowserUtils"
// module id = 147
// module chunks = 2